var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_100",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 100",
    transform: "translate(-586 -116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_24",
    "data-name": "\\u6955\\u5186\\u5F62 24",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(586 116)",
    fill: "#bdeaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_280",
    "data-name": "\\u30D1\\u30B9 280",
    d: "M132.119,113.561l-3.527-1.442a1.658,1.658,0,0,1-.965-1.505v-.52a2.183,2.183,0,0,1,.121-.722s2.218-2.96,2.218-5.69c0-3.411-2.181-5.6-4.873-5.6s-4.873,2.193-4.873,5.6c0,2.73,2.22,5.69,2.22,5.69a2.235,2.235,0,0,1,.121.722v.52a1.661,1.661,0,0,1-.967,1.505l-3.527,1.442a2.761,2.761,0,0,0-1.564,2.017l-.182,5.364h17.544l-.18-5.364A2.768,2.768,0,0,0,132.119,113.561Z",
    transform: "translate(483.407 28.49)",
    fill: "#70a76c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30CF\\u30FC\\u30C8\\u306E\\u30DE\\u30FC\\u30AF3",
    transform: "translate(605.966 142.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_287",
    "data-name": "\\u30D1\\u30B9 287",
    d: "M8.926.288A1.307,1.307,0,0,0,6.851.961,1.307,1.307,0,0,0,4.775.288a1.923,1.923,0,0,0,.044,2.695A29.466,29.466,0,0,1,6.812,5.264a.04.04,0,0,0,.077,0A29.4,29.4,0,0,1,8.882,2.983,1.923,1.923,0,0,0,8.926.288Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard-2.176a23122edabdfe53db1149fd8b270f.svg";
export { ForwardRef as ReactComponent };